import { EModeEstimationRecouvrement } from "./enum/mode-estimation-recouvrement";
import { EModeMesure } from "../Shared/enum/mode-mesure";
import { EModePrelevement } from "./enum/mode-prelevement";
import { Transect } from "./transect";

export class IBMRMesureStation {
    Longueur: number = 100;
    LmMoyenne: number;
    SurfaceTotale: number;
    ModeMesure: EModeMesure;
    ModeEstimationRecouvrement: EModeEstimationRecouvrement;
    ModePrelevement: EModePrelevement;
    LargeurStations: Transect[] = [];

    static mapFromJSON(json): IBMRMesureStation {
        const ms = new IBMRMesureStation();

        ms.Longueur = json.longueur;
        ms.LmMoyenne = json.lmMoyenne;
        ms.SurfaceTotale = json.surfaceTotale
        ms.ModeMesure = json.modeMesure
        ms.ModeEstimationRecouvrement = json.modeEstimationRecouvrement;
        ms.ModePrelevement = json.modePrelevement
        if (json.largeurStations) {
            ms.LargeurStations = json.largeurStations.map(jsonItem => Transect.mapFromJSON(jsonItem));
        }

        return ms;
    }
}